import { FC } from 'react';
// components
import ViewFormulationSyrupType from 'components/main/FormulationSyrupType/View';

const View: FC = () => <ViewFormulationSyrupType />;

export default View;
